<template>
    <v-app>
        <hrm-claim-disbursement
            :dialog="dialog" 
            :data="data" 
            @update:dialog="dialog = $event" 
        />

        <v-container fluid>
            <v-row>
                <v-col cols="12">
                        <v-card>
                            <v-card-title
                                class="text-subtitle-1 bg-blue-grey-lighten-4 mb-0"
                                > Search Form 
                            </v-card-title>
                            
                            <v-card-text>
                                <v-form @submit.prevent="submit">
                                    <v-row class="pt-4 pb-0">
                                        <v-col lg="2" md="2" cols="12">
                                            <v-date-input
                                                input-format="dd/mm/yyyy"
                                                label="From Date"
                                                density="compact"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi mdi-calendar-month"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="from_date.value.value"
                                                :error-messages="from_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-date-input>
                                        </v-col>

                                        <v-col lg="2" md="2" cols="12">
                                            <v-date-input
                                                input-format="dd/mm/yyyy"
                                                label="To Date"
                                                density="compact"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi mdi-calendar-month"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="to_date.value.value"
                                                :error-messages="to_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-date-input>
                                        </v-col>

                                        <v-col lg="2" md="2" cols="12">
                                            <v-autocomplete
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="employee_id.value.value"
                                                :error-messages="employee_id.errorMessage.value"
                                                clearable
                                                :items="getHrmEmployeeList"
                                                :item-title="item => `${item.name}`"   
                                                autocomplete="off"                                               
                                                item-value="id"
                                            
                                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                                <template #label>
                                                    Employee <span class="text-red-accent-4">*</span>
                                                </template> 
                                            </v-autocomplete>
                                        </v-col>


                                        <v-col lg="2" md="2" cols="12">
                                            <v-btn
                                                class="bg-brand w-15"
                                                type="submit"
                                                ref="searchButton"
                                            >
                                                Search
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-card-text>
                        </v-card>
                </v-col>
            </v-row>
        </v-container>

        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-card>
                        <v-card-title class="text-subtitle-1 bg-blue-grey-lighten-4 mb-0">Claim List</v-card-title>
                        <v-card-text>
                            <!-- Summary Cards -->
                            <v-row class="my-4">
                                <v-col lg="6" md="6" cols="12">
                                    <v-card class="h-full" elevation="1">
                                        <v-card-item>
                                            <v-card-title class="d-flex align-center gap-2">
                                                Total Claim Amount
                                            </v-card-title>
                                        </v-card-item>
                                        <v-card-text>
                                            <div class="text-h4 font-weight-bold text-none">
                                                {{ $number_format(getTotalClaimAmount, 2) }}
                                            </div>
                                            <div class="text-caption text-grey">
                                                Across {{ getSchema.length }} claim(s)
                                            </div>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                                <v-col lg="6" md="6" cols="12">
                                    <v-card class="h-full" elevation="1">
                                        <v-card-item>
                                            <v-card-title class="d-flex align-center gap-2">
                                                Sanctioned Amount
                                            </v-card-title>
                                        </v-card-item>
                                        <v-card-text>
                                            <div class="text-h4 font-weight-bold text-none">
                                                {{ $number_format(getSanctionedAmount, 2) }}
                                            </div>
                                            <div class="text-caption text-grey">
                                                Approved claims total
                                            </div>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                            <!-- Claim List Section -->
                            <v-row>
                                <v-col cols="12">
                                    <v-row class="py-2">
                                        <v-col md="4" cols="12">
                                            <v-text-field
                                                v-model="search"
                                                append-inner-icon="mdi-magnify"
                                                label="Search"
                                                single-line
                                                hide-details
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="pl-2"
                                                clearable
                                            ></v-text-field>
                                        </v-col>
                                        <v-col md="5" cols="12">
                                            <div class="d-flex align-center flex-column">
                                                <v-btn-group variant="outlined" density="compact" size="x-small" divided>
                                                    <v-btn prepend-icon="mdi mdi-download" variant="flat" color="success" @click="exportToCSV">CSV</v-btn>
                                                    <v-btn prepend-icon="mdi mdi-download" variant="flat" color="primary" @click="exportToExcel">EXCEL</v-btn>
                                                    <v-btn prepend-icon="mdi mdi-download" variant="flat" color="red" @click="exportToPDF">PDF</v-btn>
                                                </v-btn-group>
                                            </div>
                                        </v-col>
                                        <!-- <v-col md="3" cols="12">
                                            <div class="text-right pr-2">
                                                <v-btn
                                                    v-if="$insertAccess($route.fullPath)"
                                                    @click="goTo('/hrm/add-claim')"
                                                    color="primary"
                                                    variant="tonal"
                                                    prepend-icon="mdi mdi-plus"
                                                    rounded="xl"
                                                >
                                                    Add Claim
                                                </v-btn>
                                            </div>
                                        </v-col> -->
                                    </v-row>
                                    <v-data-table
                                        :headers="headers"
                                        :items="getSchema"
                                        :loading="loading"
                                        v-model:items-per-page="itemsPerPage"
                                        :search="search"
                                        :hover="true"
                                        density="compact"
                                    >
                                        <template v-slot:item.index="{ index }">
                                            {{ ++index }}
                                        </template>

                                        <template v-slot:item.date="{ item }">
                                            {{ formatDateView(item.date) }}
                                        </template>

                                        <template v-slot:item.claim_types="{ item }">
                                            {{ getClaimTypesString(item) }}
                                        </template>

                                        <template v-slot:item.total_amount="{ item }">
                                            {{ formatCurrency(item.total_amount) }}
                                        </template>

                                        <template v-slot:item.total_accepted_amount="{ item }">
                                            {{ formatCurrency(item.total_accepted_amount) }}
                                        </template>

                                        <template v-slot:item.approval_status_display="{ item }">
                                            <v-chip
                                                v-if="item.approval_current_process && item.approval_current_process.status === 'Pending'"
                                                color="yellow-darken-3"
                                                size="small"
                                            >
                                                Waiting for {{ item.approval_current_process.approval_step_name?.name || 'N/A' }}
                                            </v-chip>
                                            <v-chip
                                                v-else-if="item.approval_current_process && item.approval_current_process.status === 'Approved'"
                                                color="green"
                                                size="small"
                                            >
                                                Approved By {{ item.approval_current_process.approval_step_name?.name || 'N/A' }}
                                            </v-chip>
                                            <v-chip
                                                v-else-if="item.approval_current_process && item.approval_current_process.status === 'Cancelled'"
                                                color="red"
                                                size="small"
                                            >
                                                Cancelled By {{ item.approval_current_process.approval_step_name?.name || 'N/A' }}
                                            </v-chip>   
                                            <v-chip
                                                v-else
                                                :color="getApprovalStatusChipColor(item.approval_status)"
                                                size="small"
                                                class="text-capitalize"
                                            >
                                                {{ item.approval_status || 'N/A' }}
                                            </v-chip>
                                        </template>
                                        <template v-slot:item.status="{ item }">
                                            <v-chip v-if="item.status == 1" color="success" size="small" class="text-capitalize">Active</v-chip>
                                            <v-chip v-else color="red" size="small" class="text-capitalize">Inactive</v-chip>
                                        </template>
                                        <template v-slot:item.actions="{ item }">
                                            <!-- <v-icon
                                                class="me-2 edit-button"
                                                color="primary"
                                                @click="editItem(item)"
                                                v-if="$updateAccess($route.fullPath) && item.approval_status !== 'Approved'"
                                            >
                                                mdi mdi-pencil-outline
                                            </v-icon>
                                            <v-icon
                                                class="me-2 delete-button"
                                                color="red"
                                                @click="deleteItem(item)"
                                                v-if="$deleteAccess($route.fullPath) && item.approval_status !== 'Approved'"
                                            >
                                                mdi mdi-delete-outline
                                            </v-icon> -->

                                            <v-icon
                                            small
                                            @click="viewClaimInvoice(item)"
                                            class="me-2 edit-button"
                                            title="View Invoice"
                                            color="blue"
                                            >
                                                mdi-file-document-outline
                                            </v-icon>

                                            <v-icon
                                                size="small"
                                                color="success"
                                                variant="text"
                                                @click="openClaimDisbursementDialog(item)"
                                                title="Disburse"
                                                v-if="item.approval_current_process && item.approval_current_process.status === 'Approved' && item.approval_status === 'Approved' && Number(item.due_amount) !== 0"
                                            >
                                                mdi-cash-multiple
                                            </v-icon>
                                        </template>
                                    </v-data-table>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <!-- Delete Confirmation Dialog -->
        <v-dialog v-model="deleteDialog" max-width="400">
            <v-card>
                <v-card-title class="text-h6">Confirm Delete</v-card-title>
                <v-card-text>
                    Are you sure you want to delete this claim? This action cannot be undone.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn variant="text" @click="deleteDialog = false">Cancel</v-btn>
                    <v-btn color="red" variant="tonal" @click="confirmDelete" :loading="deleteLoading">
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-app>
</template>

<script>
import { formatDateView } from '@/plugins/helpers';
import { useField, useForm } from 'vee-validate';
import { toast } from 'vue3-toastify';
import * as yup from "yup";
import { ref } from 'vue';
import { useStore } from 'vuex';
import formattedDate from '@/plugins/dateFormatter';
import hrmClaimDisbursement from '@/components/module/hrm/claimsManagement/hrmClaimDisbursement.vue';


export default {
    name: 'HrmClaimList',
    components: {
        hrmClaimDisbursement
    },
    data() {
        return {
            itemsPerPage: 10,
            panel: [0],
            loading: false,
            search: "",
            dialog: false,
            data: {},
            deleteDialog: false,
            deleteLoading: false,
            selectedItem: null,
            headers: [
                { title: "#SL", align: "center", key: "index", width: "7%", sortable: false },
                { title: "Code", key: "code", align: "left", sortable: true },
                { title: "Employee Name", key: "employee.name", align: "left", sortable: true },
                { title: "Date", key: "date", align: "left", sortable: true },
                { title: "Claim Types", key: "claim_types", align: "left", sortable: false },
                { title: "Total Requested Amount", key: "total_requested", align: "right", sortable: true },
                { title: "Total Accepted Amount", key: "total_amount", align: "right", sortable: true },
                { title: "Disburse Amount", key: "disburse_amount", align: "right", sortable: true },
                { title: "Due Amount", key: "due_amount", align: "right", sortable: true },
                { title: "Approval Status", key: "approval_status_display", align: "center", sortable: false },
                { title: "Status", align: "center", key: "status", sortable: true },
                { title: "Actions", align: "center", key: "actions", sortable: false }
            ]
        };
    },


    watch: {
    },

    created() {
        // if (this.$store.getters.getHrmEmployeeList.length === 0) {
            this.$store.dispatch("getHrmEmployeeList");
        // }

        // if (this.$store.getters.getHrmClaimList.length == 0) {
            this.loading = true;
            this.$store.dispatch('getClaimList').then((response) => {
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        // }
    },

    computed: {
        getSchema() {
            return this.$store.getters.getHrmClaimList;
        },

        getHrmEmployeeList() {
            return this.$store.getters.getHrmEmployeeList;
        },

        getTotalClaimAmount() {
            return this.getSchema.reduce((total, claim) => {
                return total + (Number(claim.total_requested) || 0);
            }, 0);
        },

        getSanctionedAmount() {
            return this.getSchema.reduce((total, claim) => {
                return total + (Number(claim.total_amount) || 0);
            }, 0);
        },

        claimTypeList() {
            return this.$store.getters['hrmClaimTypeSetup/getHrmClaimTypeList'] || [];
        }
    },

    methods: {
        formatDateView,

        openClaimDisbursementDialog(item) {
            this.data = item;
            this.dialog = true;
        },
        viewClaimInvoice(item) {
            this.$router.push({
                name: "view-claim-invoice",
                params: { id: item.id }
            });
        },

        formatCurrency(amount) {
            if (!amount) return '0.00';
            return new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(amount);
        },

        getClaimTypeName(id) {
            const t = this.claimTypeList.find((ct) => ct.id == id);
            return t ? t.name : '';
        },

        getClaimTypesString(item) {
            if (!item.details || !item.details.length) return '-';
            return item.details
                .map((d) => d.claim_type?.name || this.getClaimTypeName(d.type_id || d.type) || '-')
                .join(', ');
        },

        getApprovalStatusChipColor(approvalStatus) {
            if (!approvalStatus) return 'grey';
            const s = (approvalStatus || '').toLowerCase();
            if (s === 'approved') return 'success';
            if (s === 'pending') return 'warning';
            if (s === 'rejected' || s === 'cancelled') return 'error';
            return 'grey';
        },

        getApprovalStatusDisplayText(item) {
            if (item.approval_current_process && item.approval_current_process.status === 'Pending') {
                return 'Waiting for ' + (item.approval_current_process.approval_step_name?.name || 'N/A');
            }
            if (item.approval_current_process && item.approval_current_process.status === 'Approved') {
                return 'Approved By ' + (item.approval_current_process.approval_step_name?.name || 'N/A');
            }
            if (item.approval_current_process && item.approval_current_process.status === 'Cancelled') {
                return 'Cancelled By ' + (item.approval_current_process.approval_step_name?.name || 'N/A');
            }
            return item.approval_status || 'N/A';
        },

        editItem(item) {
            this.loading = true;
            this.$store.dispatch('getClaimById', item.id)
                .then(() => {
                    if (item?.bill_type === "claim") {
                        this.$router.push({ path: '/hrm/add-claim' });
                    } else {
                        this.$router.push({ path: '/hrm/add-internal-bill' });
                    }
                })
                .catch((err) => {
                    const msg = err?.response?.data?.message || 'Failed to load claim for editing';
                    toast.error(msg);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        deleteItem(item) {
            this.selectedItem = item;
            this.deleteDialog = true;
        },

        confirmDelete() {
            if (!this.selectedItem) return;

            this.deleteLoading = true;
            this.$store.dispatch('deleteClaim', this.selectedItem.id)
                .then(() => {
                    toast.success('Claim deleted successfully');
                    this.deleteDialog = false;
                    this.selectedItem = null;
                    this.$store.dispatch('getClaimList');
                })
                .catch(() => {
                    toast.error('Failed to delete claim');
                })
                .finally(() => {
                    this.deleteLoading = false;
                });
        },

        goTo(path) {
            this.$router.push(path);
        },

        exportToPDF() {
            let serialNumber = 1;
            const columns = ['#SL', 'Code', 'Date', 'Claim Types', 'Total Amount', 'Approval Status', 'Status'];
            const rows = this.getSchema.map(item => [
                serialNumber++,
                item.code,
                this.formatDateView(item.date),
                this.getClaimTypesString(item),
                this.formatCurrency(item.total_amount),
                this.getApprovalStatusDisplayText(item),
                item.status == 1 ? 'Active' : 'Inactive'
            ]);
            this.$exportTableToPDF(columns, rows, 'Claim List', 'claim_list_' + this.$fileDate());
        },

        exportToExcel() {
            var data = [['#SL', 'Code', 'Date', 'Claim Types', 'Total Amount', 'Approval Status', 'Status']];
            var serialNumber = 1;
            this.getSchema.forEach(item => {
                data.push([
                    serialNumber++,
                    item.code,
                    this.formatDateView(item.date),
                    this.getClaimTypesString(item),
                    this.formatCurrency(item.total_amount),
                    this.getApprovalStatusDisplayText(item),
                    item.status == 1 ? 'Active' : 'Inactive'
                ]);
            });
            this.$exportTableToExcel(data, 'claim_list_' + this.$fileDate());
        },

        exportToCSV() {
            var data = [['#SL', 'Code', 'Date', 'Claim Types', 'Total Amount', 'Approval Status', 'Status']];
            var serialNumber = 1;
            this.getSchema.forEach(item => {
                data.push([
                    serialNumber++,
                    item.code,
                    this.formatDateView(item.date),
                    this.getClaimTypesString(item),
                    this.formatCurrency(item.total_amount),
                    this.getApprovalStatusDisplayText(item),
                    item.status == 1 ? 'Active' : 'Inactive'
                ]);
            });
            this.$exportTableToCSV(data, 'claim_list_' + this.$fileDate());
        }
    },

        setup() {
            const { handleSubmit, resetForm} = useForm({
                validationSchema: yup.object({
                    // from_date: yup.date().required().label('From Date'),
                    // to_date: yup.date().required().label('To Date'),
                }),
            });

            const from_date = useField("from_date");
            const to_date = useField("to_date");
            const employee_id = useField("employee_id");
            const errorMessages = ref("");
            const loading = ref("");
            const store = useStore();
            const submit = handleSubmit((values) => {
            loading.value = true;
            values.from_date = formattedDate(from_date.value.value);
            values.to_date = formattedDate(to_date.value.value);
            store
                .dispatch("getClaimList", values)
                .then((response) => {
                loading.value = false;
                })
                .catch((error) => {
                toast.error(error.response.data.message);
                });
            });
        return {
            submit,
            employee_id,
            from_date,
            to_date,
            errorMessages,
            loading,
        };
    },

    mounted() {
        this.$nextTick(() => {
            this.$refs.searchButton.$el.click();
        });
    }
};
</script>

<style scoped>
.panel-header {
    font-weight: 600;
}

:deep(.v-data-table thead th) {
    padding: 12px 16px !important;
    margin-bottom: 8px;
}

:deep(.v-data-table tbody td) {
    padding: 8px 16px !important;
}

.edit-button,
.delete-button {
    cursor: pointer;
}

.edit-button:hover,
.delete-button:hover {
    opacity: 0.7;
}

  .v-card-title {
    height: 40px;
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 500;
}
</style>